export default {
  id: null,
  name: null,
  email: null,
  rfc: null,
  curp: null,
  socialSecurityNumber: null,
  jobRelationshipStart: null,
  seniority: null,
  contractType: null,
  unionized: null,
  workingDayType: null,
  regimeType: null,
  employedNumber: null,
  department: null,
  position: null,
  hazardPosition: null,
  paymentPeriodicity: null,
  bank: null,
  bankAccount: null,
  baseSalary: null,
  dailyBaseSalary: null,
  localityKey: null,
  success: '',
  message: false,
  payments: [],
};
